
export const initDeepLinking = (lightbox, transformedData, slug) => {
    lightbox.on('change', () => {
      const currentSlide = lightbox.pswp.currSlide;
      const slideId = currentSlide.data.id;
      const newUrl = `${window.location.pathname}#${slug}-${slideId}`;
      history.pushState(null, '', newUrl);
    });
  
    lightbox.on('close', () => {
      history.pushState(null, '', window.location.pathname);
    });
  
    const hash = window.location.hash;
    if (hash) {
      const slideId = hash.split(slug+'-')[1];
      const index = transformedData.findIndex(item => item.id == slideId);
      if (index !== -1) {
        lightbox.loadAndOpen(index);
      }
    }
  };